/* eslint-disable no-unused-vars */
import httpService from '@/services/httpService'
import _ from 'lodash'
import mt from 'moment-timezone'
import vue from '@/main'
import ToasterService from '@/services/toasterService'
import { convertAdvancedOptionsToURLParams } from '@/store/modules/rank-zone/Helper'
import RankZone from '../../../features/content-briefs/brief-content/RankZone'
import ContentBrief from '../../../features/content-briefs/brief-content/index.vue'

export const types = {
  ADD_BRIEF_CONTENT: 'brief-content/ADD_BRIEF_CONTENT',
  ADD_BRIEF_CONTENT_BASELINE: 'brief-content/ADD_BRIEF_CONTENT_BASELINE',
  REMOVE_BRIEF_CONTENT_BASELINE: 'brief-content/REMOVE_BRIEF_CONTENT_BASELINE',
  ADD_COMMENTS: 'brief-content/ADD_COMMENTS',
  ADD_ONE_COMMENT: 'brief-content/ADD_ONE_COMMENT',
  ADD_SNAPSHOT: 'brief-content/ADD_SNAPSHOT',
  ADD_KEYWORDS_SNAPSHOT: 'brief-content/ADD_KEYWORDS_SNAPSHOT',
  ADD_WORDS: 'brief-content/ADD_WORDS',
  ADD_BRIEF_PROGRESS_DATA: 'brief-content/ADD_BRIEF_PROGRESS_DATA',
  RESET_WORDS: 'brief-content/RESET_WORDS',
  RESET_BRIEF_CONTENT_DATA: 'brief-content/RESET_BRIEF_CONTENT_DATA',
  UPDATE_KEYWORD_SCORE: 'brief-content/UPDATE_KEYWORD_SCORE',
  SORT_ANNOTATIONS: 'brief-content/SORT_ANNOTATIONS',
  CHANGE_BRIEF_URL: 'brief-content/CHANGE_BRIEF_URL',
  CHANGE_BRIEF_CONTENT_PRIMARY_BASELINE: 'brief-content/CHANGE_BRIEF_CONTENT_PRIMARY_BASELINE'
}

export const EMPTY_BRIEF_CONTENT = {
  client: {
    name: '',
    _id: 0
  },
  _id: '',
  share_link: '',
  metrics: {
    monthly_search_volume: 0,
    first_page_coverage: 0,
    keyword_count: 0
  },
  name: '',
  url: '',
  available_integrations: [],
  integrations: [],
  url_id: '',
  writing_status_id: '',
  fk_user_id_strategist: '',
  fk_user_id_writer: '',
  page_type: '',
  tag_title_current: '',
  tag_meta_description_current: '',
  tag_meta_description_recommended: '',
  tag_title_recommended: '',
  tag_h1_current: '',
  tag_h1_recommended: '',
  tag_meta_description_optimized: '',
  tag_title_optimized: '',
  keywords: [],
  attachements: [],
  guidelines: '',
  summary: '',
  content_optimized: '',
  content: '',
  comments: [],
  snapshots: [],
  words: [],
  progress: [],
  annotations: [],
  snapshot_dates: [],
  baselines: [],
  url_attributes: 0,
  isWordsFetched: false,
  snapshotsData: {
    0: null,
    1: null
  },
  selectedDate: null,
  page_type: '',
  page_type_id: '',
  section: '',
  section_id: ''
}

const state = {
  briefContent: {
    ...EMPTY_BRIEF_CONTENT
  }
}

const mutations = {
  [types.ADD_BRIEF_CONTENT]: function (state, briefContentInfo) {
    if (briefContentInfo.fk_user_id_strategist < 0) {
      briefContentInfo.fk_user_id_strategist = ''
    }
    if (briefContentInfo.fk_user_id_writer < 0) {
      briefContentInfo.fk_user_id_writer = ''
    }
    if (briefContentInfo.page_type_id === '' ) {
      briefContentInfo.page_type_id = null
    }
    if (briefContentInfo.section_id === '' ) {
      briefContentInfo.section_id = null
    }
    state.briefContent = { ...state.briefContent, ...briefContentInfo }
  },
  [types.ADD_BRIEF_CONTENT_BASELINE]: function (state, { newBaseLine }) {
    state.briefContent.baselines = [newBaseLine, ...state.briefContent.baselines]
  },
  [types.CHANGE_BRIEF_CONTENT_PRIMARY_BASELINE]: function (state, baselineId) {
    let isPrimarySet = false
    state.briefContent.baselines = state.briefContent.baselines.map(baseline => {
      if (baseline.is_primary) {
        baseline.is_primary = false
      }
      if (baseline.id === baselineId) {
        baseline.is_primary = true
        isPrimarySet = true
      }
      return baseline
    })
    if (!isPrimarySet) {
      const oldest = state.briefContent.baselines.slice().sort((a, b) => new Date(a.date) - new Date(b.date))[0]
      state.briefContent.baselines.find(baseline => baseline.id === oldest.id).is_primary = true
    }
  },
  [types.REMOVE_BRIEF_CONTENT_BASELINE]: function (state, baselineId) {
    state.briefContent.baselines = state.briefContent.baselines.filter(item => item.id !== baselineId)
  },
  [types.ADD_COMMENTS]: function (state, comments) {
    const timezone = mt.tz.guess()
    state.briefContent.comments = comments.map(comment => Object.assign(comment, { timestamp: mt.utc(comment.timestamp).tz(timezone).format() }))
  },
  [types.ADD_WORDS]: function (state, { words }) {
    state.briefContent.words = words.map(item => [item.word, item.score]) || []
    state.briefContent.isWordsFetched = true
  },
  [types.RESET_WORDS]: function (state) {
    state.briefContent.words = []
    state.briefContent.isWordsFetched = false
  },
  [types.ADD_ONE_COMMENT]: function (state, comment) {
    const timezone = mt.tz.guess()
    state.briefContent.comments.push(Object.assign(comment, { timestamp: mt.utc(comment.timestamp).tz(timezone).format() }))
    state.briefContent.comments = [...state.briefContent.comments]
  },
  [types.CHANGE_BRIEF_URL]: function (state, name) {
    const a = document.createElement('a')
    a.href = state.briefContent.url
    state.briefContent.url = a.origin + (name.startsWith('/') ? name : '/' + name)
  },
  [types.ADD_SNAPSHOT]: function (state, { data, index }) {
    const snapshotsData = { ...state.briefContent.snapshotsData, [index]: data }
    state.briefContent = { ...state.briefContent, ...{ snapshotsData } }
  },
  [types.ADD_BRIEF_PROGRESS_DATA]: function (state, { progress, snapshot_dates, annotations = [] }) {
    state.briefContent.snapshot_dates = snapshot_dates || []
    state.briefContent.progress = progress || []
    state.briefContent.annotations = annotations.map(i => {
      i.isEdit = false
      i.prevNote = i.note
      i.prevDate = i.date
      i.prevType = i.type
      i.disableButtons = false
      i.errorFields = []
      return i
    })
  },
  [types.ADD_KEYWORDS_SNAPSHOT]: function (state, { keywords, metrics }) {
    state.briefContent.keywords = keywords
    state.briefContent.metrics = metrics
  },
  [types.UPDATE_KEYWORD_SCORE]: function (state, { score, keywordId, is_diff_update, diff_score }) {
    const keywords = [...state.briefContent.keywords]
    let itemIndex
    const updatedKeyword = keywords.find((item, index) => {
      if (item._id === keywordId) {
        itemIndex = index
        return true
      }
      return false
    })
    if (is_diff_update) {
      updatedKeyword.diff_score = parseInt(diff_score)
    } else {
      updatedKeyword.score = parseInt(score)
    }
    keywords[itemIndex] = updatedKeyword
    state.briefContent.keywords = _.cloneDeep(keywords)
  },
  [types.SORT_ANNOTATIONS]: function (state) {
    state.briefContent.annotations = state.briefContent.annotations.sort((a, b) => new Date(b.date) - new Date(a.date))
  }
}

const actions = {
  getBriefContent: async function ({ commit, dispatch, rootState }, { briefId, clientId, reset = true }) {
    dispatch('breadcrumb/resetBriefContentName', null, { root: true })
    reset && dispatch('resetBriefContent')
    const msv = JSON.parse(localStorage.getItem('msv')) || {}
    const params = {
      msv: msv[clientId] || 1
    }
    const briefContentInfo = await httpService.get(
      `/content-briefs/get-content-brief/${briefId}`,
      { params, raiseError: true },
      {
        cancel: true,
        cancelToken: '/content-briefs/get-content-brief/'
      }
    )
    if (!briefContentInfo || !briefContentInfo.data) {
      return
    }
    const client = rootState.clients.find(client => client._id === briefContentInfo.data.client._id)
    if (client) {
      dispatch('breadcrumb/setBriefContentName', briefContentInfo.data, { root: true })
      const currentUser = rootState.currentUser
      // we need it if we start app right from contentBrief link and there is different client that was set earlier
      dispatch('setSelectedClient', { selectedClient: client, currentUserId: currentUser._id }, { root: true })
      commit(types.ADD_BRIEF_CONTENT, briefContentInfo.data)
    } else {
      ToasterService.showToast(ToasterService.ERROR_TYPE, 'Forbidden. You are not allowed to access this resource.')
      vue.$router.navigateToEntryPoint()
    }
  },
  createContentBrief: async function({ commit }, params) {
    try {
      const response =  await httpService.post(
        `/content-briefs/create-content-brief`,
        params,
        {isFormData: true, raiseError: true}
      )
      return response
    } catch(e) {
      return e;
    }
  },
  createContentBriefVersion: async function ({ commit }, { briefId, ...params }) {
    const response = await httpService.post(
      `/content-briefs/create-content-brief-baseline/${briefId}`,
      params,
      { successMessage: 'Successfully created new baseline' }
    )
    if (!response || !response.data) {
      return
    }
    commit(types.ADD_BRIEF_CONTENT_BASELINE, {
      newBaseLine: response.data.baseline
    })
  },
  deleteContentBriefVersion: async function ({ commit }, { cbVersionId, briefId }) {
    const response = await httpService.delete(
      `/content-briefs/remove-content-brief-baseline/${briefId}`,
      { successMessage: 'Content Brief Baseline removed successfully', params: { cbVersionId } }
    )
    if (!response || !response.data) {
      return
    }
    commit(types.REMOVE_BRIEF_CONTENT_BASELINE, cbVersionId)
    commit(types.CHANGE_BRIEF_CONTENT_PRIMARY_BASELINE, cbVersionId)
  },
  changeContentBriefVersion: async function ({ commit }, { briefId, ...params }) {
    const response = await httpService.patch(
      `/content-briefs/change-content-brief-baseline/${briefId}`,
      params,
      { successMessage: 'Content Brief Baseline changed successfully' }
    )
    if (!response || !response.data) {
      return
    }
    return response
  },
  changePrimaryBaseline: async function ({ commit }, { baselineId }) {
    const response = await httpService.patch(
      `/content-briefs/change-primary-baseline/${baselineId}`, null,
      { successMessage: 'Primary Baseline changed successfully' }
    )
    if (!response || !response.data) {
      return
    }
    commit(types.CHANGE_BRIEF_CONTENT_PRIMARY_BASELINE, baselineId)
  },
  getComments: async function ({ commit }, { briefId }) {
    const response = await httpService.get(`/content-briefs/get-comments/${briefId}`)
    if (!response || !response.data) {
      return
    }
    commit(types.ADD_COMMENTS, response.data.comments)
  },
  getUrlBaselineBody: async function ({ commit }, briefId) {
    const response = await httpService.get(`/content-briefs/get-url-baseline-body/${briefId}`)
    if (!response || !response.data) {
      return {
        content: '',
        title: '',
        desc: ''
      }
    }
    return response.data
  },
  getKeywordsSnapshot: async function ({ commit }, { briefId, snapshotDate, clientId, web_property_group_id }) {
    commit(types.ADD_KEYWORDS_SNAPSHOT, { keywords: [], metrics: {} })
    const msv = JSON.parse(localStorage.getItem('msv')) || {}
    const params = {
      snapshot_date: snapshotDate,
      web_property_group_id,
      msv: msv[clientId] || 1
    }
    const response = await httpService.get(`/content-briefs/get-keywords-snapshot/${briefId}`, { params: params })
    if (!response || !response.data) {
      return
    }
    commit(types.ADD_KEYWORDS_SNAPSHOT, response.data)
  },
  getKeywordsBaselineSnapshot: async function ({ commit }, { cbVersionId, briefId, snapshotDate, optimizedContent, clientId }) {
    httpService.breakRequestByURL(`/content-briefs/get-optimized-kiss-score/${briefId}`)
    commit(types.ADD_KEYWORDS_SNAPSHOT, { keywords: [], metrics: {} })
    const msv = JSON.parse(localStorage.getItem('msv')) || {}
    const params = {
      snapshot_date: snapshotDate,
      optimizedContent,
      cbVersionId,
      msv: msv[clientId] || 1
    }
    const response = await httpService.post(`/content-briefs/get-optimized-kiss-score/${briefId}`, params)
    if (!response || !response.data) {
      return
    }
    commit(types.ADD_KEYWORDS_SNAPSHOT, response.data)
  },
  addComment: async function ({ commit }, { briefId, comment }) {
    comment.comment = comment.comment.replace(/(?:\r\n|\r|\n)/g, '<br>')
    const formattedData = { comment: comment.comment }
    const response = await httpService.post(`/content-briefs/post-comment/${briefId}`, formattedData)
    if (!response || !response.data) {
      return
    }
    commit(types.ADD_ONE_COMMENT, comment)
  },
  shareBrief: function (store, { shareData, briefId }) {
    httpService.post(`/content-briefs/email-share-link/${briefId}`, shareData,
      { successMessage: 'Successfully Shared!' })
  },
  changeContentBrief: function ({ commit, rootState },
    { clientId, briefStatusId = null, summary = null, urlStatusId = null,
      description = null, date = null, calendarId = null, briefId,
      tag_title_recommended = null, tag_meta_description_recommended = null, successMessage = null,
      tag_h1_recommended = null, name = null, is_optimized = null, content = null,
      is_refresh_meta_data = null, content_optimized = null, tag_meta_description_optimized = null,
      tag_title_optimized = null, fk_user_id_strategist = null, fk_user_id_writer = null, page_type_id = null,
      section_id = null, url = null, url_id = null, silentMode = false, published_url = null, published_url_id = null
    }) {
    const params = {
      brief_id: briefId,
      brief_status_id: briefStatusId,
      url_status_id: urlStatusId,
      calendar_id: calendarId,
      name,
      summary,
      description,
      date,
      is_optimized,
      tag_title_recommended,
      tag_title_optimized,
      tag_meta_description_optimized,
      content_optimized,
      tag_meta_description_recommended,
      tag_h1_recommended,
      content,
      is_refresh_meta_data,
      fk_user_id_strategist,
      fk_user_id_writer,
      page_type_id,
      section_id,
      url,
      url_id,
      published_url,
      published_url_id
    }
    const updateData = {}
    const argumentsList = ['summary', 'briefStatusId', 'urlStatusId', 'date', 'tag_title_recommended', 'tag_meta_description_recommended',
      'tag_h1_recommended', 'name', 'is_optimized', 'content', 'content_optimized', 'tag_title_optimized', 'tag_meta_description_optimized',
      'fk_user_id_writer', 'fk_user_id_strategist', 'page_type_id', 'section_id', 'url', 'url_id', 'published_url', 'published_url_id']
    const updateArguments = Object.keys(arguments[1])
    argumentsList.forEach(item => {
      if (updateArguments.includes(item)) {
        if (item === 'date') {
          updateData.target_publish_date = arguments[1][item]
        } else if (['briefStatusId', 'urlStatusId'].includes(item)) {
          const statusesFields = item === 'briefStatusId'
            ? ['contentBriefStatuses', 'content_brief_status', 'content_brief_status_id']
            : ['urlStatuses', 'url_status', 'url_status_id']
          const statusData = rootState[statusesFields[0]].find(i => i._id === arguments[1][item])
          updateData[statusesFields[1]] = statusData.label
          updateData[statusesFields[2]] = statusData._id
        } else {
          updateData[item] = arguments[1][item]
        }
      }
    })
    commit(types.ADD_BRIEF_CONTENT, updateData)
    if (name) {
      commit(types.CHANGE_BRIEF_URL, name)
    }
    const messageOnSuccess = silentMode ? null : successMessage || 'Successfully updated'
    return httpService.patch(`/content-briefs/change-content-brief/${clientId}`, params,
      { raiseError: true, successMessage: messageOnSuccess })
  },
  updateScore: function ({ commit }, { clientId, briefId, keywordId, score, is_diff_update, diff_score }) {
    const params = {
      brief_id: briefId,
      keyword_id: keywordId,
      score,
      diff_score,
      is_diff_update
    }
    commit(types.UPDATE_KEYWORD_SCORE, { score, keywordId, is_diff_update, diff_score })
    return httpService.patch(`/content-briefs/update-keyword-score/${clientId}`, params,
      { raiseError: true, successMessage: 'Successfully updated' })
  },
  /**
   * used in {@link RankZone}
   */
  getSnapshotData: async function ({ commit }, { filters, clientId }) {
    const { snapshotDate1, snapshotDate2, contentBriefId, index1, index2, advancedFilters, web_property_group_id } = filters

    const msv = JSON.parse(localStorage.getItem('msv')) || {}
    let params = null
    if (advancedFilters) {
      filters = {
        snapshot_date_1: snapshotDate1,
        snapshot_date_2: snapshotDate2,
        web_property_group_id: web_property_group_id,
        msv: msv[clientId] || 1,
        advancedFilters
      }
      params = convertAdvancedOptionsToURLParams(filters)
    } else {
      params = {
        msv: msv[clientId] || 1,
        snapshot_date_1: snapshotDate1,
        snapshot_date_2: snapshotDate2,
        web_property_group_id: web_property_group_id
      }
    }
    // if we not fetching snapshots, but updating one we should only reset data by given indexToUpdate
    commit(types.ADD_SNAPSHOT, { data: null, index: index1 })
    commit(types.ADD_SNAPSHOT, { data: null, index: index2 })
    const response = await httpService.get(`/content-briefs/compare-snapshots/${contentBriefId}`, { params: params },
      { cancel: true, cancelToken: '/content-briefs/compare-snapshots/' })
    // if indexToUpdate is undefined than it means that snapshots are not updated & we should reset data for both indexes
    commit(types.ADD_SNAPSHOT, { data: response.data[0], index: index1 })
    commit(types.ADD_SNAPSHOT, { data: response.data[1], index: index2 })
  },
  async getWordCloud ({ commit, dispatch }, briefId) {
    if (!briefId) {
    }
    commit(types.RESET_WORDS)
    const response = await httpService.get(`/content-briefs/word-cloud/${briefId}`)
    if (response && response.data) {
      commit(types.ADD_WORDS, response.data)
    }
  },
  async patchPublishingProperties ({ commit }, { briefId, data, isDelete }) {
    return httpService.patch(`/content-briefs/publishing/properties/${briefId}`, { data },
      { raiseError: true, successMessage: 'Successfully updated' })
  },
  async getPublishingData ({ commit }, versionId) {
    return httpService.get(`/content-briefs/publishing/${versionId}`)
  },
  async getHistoricPublishingData ({ commit }, publishQueueId) {
    return httpService.get(`/content-briefs/publishing/history/${publishQueueId}`)
  },
  async publishBrief ({ commit }, { briefId, versionId, method, unpublish }) {
    return httpService.post(`/content-briefs/publishing/${briefId}`, { versionId, method, unpublish },
      { raiseError: true, successMessage: 'Added to Publishing queue' })
  },
  async detachFromAsana ({ commit }, briefId) {
    return httpService.post(`/content-briefs/detach-asana/${briefId}`, null,
      { raiseError: true, successMessage: 'Detached from Asana' })
  },
  async addNewAttachment ({ commit }, { briefId, successMessage, method, data }) {
    const request = httpService[method]
    const response = request(`/content-briefs/change-attachment/${briefId}`, data,
      {
        isFormData: true,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        successMessage,
        raiseError: true,
        cancelErrorMessage: true
      }
    )
    if (!response) {
      return
    }

    return response
  },
  async removeAttachment (store, attachmentId) {
    const response = await httpService.delete(`/content-briefs/remove-attachment/${attachmentId}`, { successMessage: 'Attachment removed successfully' })
    if (!response) {
      return false
    }

    return response.data.is_removed
  },
  sharePdf: function (store, { pdfData, briefId }) {
    httpService.get(`/content-briefs/email-share-pdf/${briefId}`, { params: pdfData }, { successMessage: 'Successfully Shared!' })
  },
  resetBriefContent ({ commit }) {
    commit(types.ADD_BRIEF_CONTENT, EMPTY_BRIEF_CONTENT)
  },
  getProgressData: async function ({ commit, dispatch, rootState }, { clientId, filters }) {
    dispatch('resetProgressData')
    const msv = JSON.parse(localStorage.getItem('msv')) || {}
    filters.msv = msv[clientId] || 1
    let params = null
    if (filters && filters.advancedFilters) {
      params = convertAdvancedOptionsToURLParams(filters)
    } else {
      params = filters
    }
    const response = await httpService.get(`/reports/rankzone-report/progress/${clientId}`, { params: params },
      { encode: false, cancel: true, cancelToken: '/content-briefs/progress/' })
    if (!response || !response.data) {
      return
    }
    commit(types.ADD_BRIEF_PROGRESS_DATA, response.data)
  },
  resetProgressData: function ({ commit }) {
    commit(types.ADD_BRIEF_PROGRESS_DATA, {})
  },
  sortAnnotations: async function ({ commit }) {
    commit(types.SORT_ANNOTATIONS)
  }
}

/**
 * Store manage data of specific content brief {@link ContentBrief}
 */
export default {
  namespaced: true,
  state,
  actions,
  mutations
}
